import { render, staticRenderFns } from "./CollegePurchaseHod.vue?vue&type=template&id=bf66c4e4"
import script from "./CollegePurchaseHod.vue?vue&type=script&lang=js"
export * from "./CollegePurchaseHod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports